import {    
    DecisionCodeApiDecisionCodeGetDecisionCodesForCustomerRequest,
    DetermineDecisionCodesRequest,
    DetermineDecisionCodesResponse,
    DecisionCodesResult,
} from 'returnCenter-api';
import { decisionCodeApi } from './api';
import { getLanguage } from './languageStore';

/**
 * Decision Code service - handles decision code-related API calls
 * Maps to DecisionCodeController endpoints
 */
export const decisionCodeService = {
    /**
     * Determine decision codes for items based on business rules
     */
    determineDecisionCodes: async (
        request: DetermineDecisionCodesRequest,
    ): Promise<DetermineDecisionCodesResponse> => {
        const response = await decisionCodeApi.decisionCodeDetermineDecisionCodesPOST({
            determineDecisionCodesRequest: request,
        });
        return response.data;
    },

    /**
     * Get available decision codes for a specific customer
     */
    getDecisionCodesForCustomer: async (
        request: DecisionCodeApiDecisionCodeGetDecisionCodesForCustomerRequest,
    ): Promise<DecisionCodesResult> => {
        const response = await decisionCodeApi.decisionCodeGetDecisionCodesForCustomer({
            language: getLanguage(),
            ...request,
        });
        return response.data;
    },
};
